import { StateType } from '../index';

import { UI } from './types';

export const UISelectors = {
  selectIsDarkMode: (state: StateType) => state[UI].isDarkMode,
};
